import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { MERCHANT_BASE_URL } from "./links";

export const API_URL = process.env.REACT_APP_API_URL;
const isLocalhost = window.location.hostname.includes("localhost");

// Env is picked via IS_STAGING rather than API_URL.includes("staging") — under cookie auth
// API_URL is "/" in dev, which would otherwise read as production.
const appOrigin = isLocalhost
  ? `http://localhost:${window.location.port}`
  : MERCHANT_BASE_URL;

export const APP_BUSINESS_URL = `${appOrigin}/business-page`;

export const APP_SINGLE_BUSINESS_URL = `${appOrigin}/payment-page`;

export const options = [
  { value: "agriculture", label: "Agriculture" },
  { value: "arts_and_crafts", label: "Arts and Crafts" },
  { value: "automotive", label: "Automotive" },
  { value: "beauty_and_wellness", label: "Beauty and Wellness" },
  { value: "catering", label: "Catering" },
  { value: "charity", label: "Charity" },
  { value: "church", label: "Church" },
  { value: "cleaning_services", label: "Cleaning Services" },
  { value: "clothing", label: "Clothing" },
  { value: "construction", label: "Construction" },
  { value: "consulting", label: "Consulting" },
  { value: "crypto_and_blockchain", label: "Cryptocurrency and Blockchain" },
  { value: "education", label: "Education" },
  { value: "ecommerce", label: "E-Commerce" },
  { value: "electronics", label: "Electronics" },
  { value: "energy", label: "Energy" },
  { value: "entertainment", label: "Entertainment" },
  { value: "environmental_services", label: "Environmental Services" },
  { value: "event_management", label: "Event Management" },
  { value: "fashion", label: "Fashion" },
  { value: "finance", label: "Finance" },
  { value: "fitness_and_recreation", label: "Fitness and Recreation" },
  { value: "food_and_beverage", label: "Food and Beverage" },
  { value: "freelancing", label: "Freelancing" },
  { value: "gaming", label: "Gaming" },
  { value: "government", label: "Government" },
  { value: "grocery", label: "Grocery" },
  { value: "healthcare", label: "Healthcare" },
  { value: "hospitality", label: "Hospitality" },
  { value: "import_and_export", label: "Import and Export" },
  { value: "insurance", label: "Insurance" },
  { value: "it_services", label: "IT Services" },
  { value: "legal_services", label: "Legal Services" },
  { value: "logistics", label: "Logistics" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "marketing_and_advertising", label: "Marketing and Advertising" },
  { value: "media", label: "Media" },
  { value: "ministry", label: "Ministry" },
  { value: "mosque", label: "Mosque" },
  { value: "music_and_audio", label: "Music and Audio" },
  { value: "ngo", label: "Non-Governmental Organization (NGO)" },
  { value: "non_profit", label: "Non-Profit" },
  { value: "petroleum_and_gas", label: "Petroleum and Gas" },
  { value: "pharmaceuticals", label: "Pharmaceuticals" },
  { value: "photography", label: "Photography" },
  { value: "printing_and_publishing", label: "Printing and Publishing" },
  { value: "professional_services", label: "Professional Services" },
  { value: "real_estate", label: "Real Estate" },
  { value: "religious_institution", label: "Religious Institution" },
  { value: "restaurant", label: "Restaurant" },
  { value: "retail", label: "Retail" },
  { value: "security_services", label: "Security Services" },
  { value: "sports", label: "Sports" },
  { value: "technology", label: "Technology" },
  { value: "telecommunications", label: "Telecommunications" },
  { value: "transportation", label: "Transportation" },
  { value: "travel", label: "Travel" },
  { value: "other", label: "Other" },
];

export const socials = [
  {
    id: "social-1",
    icon: FaInstagram,
    color: "#F00073",
    link: "https://www.instagram.com/deex_options?igsh=aTVxaWNsdXlnNXA4",
    description: "instagram",
  },
  {
    id: "social-2",
    icon: FaFacebook,
    color: "#1877F2",
    link: "https://www.facebook.com/profile.php?id=100089488502613&mibextid=LQQJ4d",
    description: "facebook",
  },
  {
    id: "social-3",
    icon: FaLinkedin,
    color: "#2867B2",

    link: "https://www.linkedin.com/company/deexoptions/about/",
    description: "linkedIn",
  },
  {
    id: "social-4",
    icon: FaTwitter,
    color: "#1DA1F2",

    link: "https://twitter.com/deexoptions?t=R__Hq9LKxZ8V0kyqtQkhZg&s=09",
    description: "twitter",
  },
];

type NetworkName = "BSC" | "ETH" | "TRX" | "BTC" | "SOL" | "DOGE" | "MATIC" | "POL" | "POLYGON";

/** Display labels for chain codes — same map as deex-new-pwa. */
export const NETWORK_LABEL_MAP: Record<NetworkName, string> = {
  BSC: "BEP-20",
  ETH: "ERC-20",
  TRX: "TRC-20",
  BTC: "BTC",
  SOL: "SOL",
  DOGE: "DOGE",
  MATIC: "Polygon",
  POL: "Polygon",
  POLYGON: "Polygon",
};

export const getNetworkLabel = (network: string) =>
  NETWORK_LABEL_MAP[network as NetworkName] ?? network;

export const depCoins = [
  {
    id: 1,
    name: "Bitcoin",
    abbr: "BTC",

    networks: [
      {
        id: 12,
        name: "BTC",
      },
    ],
  },
  {
    id: 2,
    name: "Tether",
    abbr: "USDT",
    networks: [
      {
        id: 21,
        name: "BSC",
      },
      {
        id: 22,
        name: "ETH",
      },
      {
        id: 23,
        name: "TRX",
      },
      {
        id: 24,
        name: "SOL",
      },
    ],
  },
  {
    id: 3,
    name: "Ethereum",
    abbr: "ETH",
    networks: [
      {
        id: 31,
        name: "BSC",
      },
      {
        id: 32,
        name: "ETH",
      },
    ],
  },
  {
    id: 4,
    name: "Doge",
    abbr: "DOGE",
    networks: [
      {
        id: 41,
        name: "DOGE",
      },
    ],
  },
  {
    id: 5,
    name: "Shiba Inu",
    abbr: "SHIB",
    networks: [
      {
        id: 51,
        name: "BSC",
      },
      {
        id: 52,
        name: "ETH",
      },
    ],
  },
  {
    id: 6,
    name: "Solana",
    abbr: "SOL",

    networks: [
      {
        id: 61,
        name: "SOL",
      },
    ],
  },
  {
    id: 7,
    name: "Tron",
    abbr: "TRX",

    networks: [
      {
        id: 71,
        name: "TRX",
      },
    ],
  },
  {
    id: 8,
    name: "USD Circle",
    abbr: "USDC",

    networks: [
      {
        id: 81,
        name: "BSC",
      },
      {
        id: 82,
        name: "ETH",
      },
      {
        id: 83,
        name: "SOL",
      },
    ],
  },
  {
    id: 9,
    name: "BNB",
    abbr: "BNB",

    networks: [
      {
        id: 91,
        name: "BSC",
      },
      {
        id: 92,
        name: "ETH",
      },
    ],
  },
  {
    id: 10,
    name: "Polygon",
    abbr: "POL",
    aliases: ["MATIC"],

    networks: [
      {
        id: 101,
        name: "ETH",
      },
      {
        id: 102,
        name: "MATIC",
      },
      {
        id: 103,
        name: "BSC",
      },
    ],
  },
];
